let countriesModule: typeof import("i18n-iso-countries") | null = null;

async function getCountries() {
	if (countriesModule) return countriesModule;

	const [countries, deLocale, enLocale] = await Promise.all([
		import("i18n-iso-countries"),
		import("i18n-iso-countries/langs/de.json"),
		import("i18n-iso-countries/langs/en.json"),
	]);

	// entry.client.tsx suppresses vite:preloadError while it reloads the page,
	// which makes Vite resolve a failed chunk import to undefined.
	if (!countries || !deLocale || !enLocale) return null;

	countries.registerLocale(deLocale);
	countries.registerLocale(enLocale);
	countriesModule = countries;
	return countries;
}

export async function translateCountryName(
	name: string,
	targetLang: string,
	sourceLang = "de",
) {
	const countries = await getCountries();
	if (!countries) {
		return name;
	}

	const countryCode = countries.getAlpha2Code(name, sourceLang);

	if (!countryCode) {
		return name;
	}

	const translatedName = countries.getName(countryCode, targetLang);

	return translatedName || name;
}
